import gql from 'graphql-tag'

export const CASE_STUDY_PAGE_QUERY = gql`
query {
  caseStudyPage {
    data {
      id
      attributes {
        intro {
          Intro {
            Title
            Description
            Caption
          }
        }
        HireUs {
          Title
          Caption
          Description
        }
        Button {
          href
          label
          isExternal
        }
        Seo {
          metaTitle
          metaDescription
          metaImage {
            data {
              attributes {
                url
                alternativeText
                formats
              }
            }
          }
          metaSocial {
            socialNetwork
            title
            description
            image {
              data {
                attributes {
                  url
                  alternativeText
                  formats
                }
              }
            }
          }
        }
      }
    }
  }
}
`;
